import React from 'react';
import MaterialDialogTitle from '@mui/material/DialogTitle';
import type {DialogTitleProps as MaterialDialogTitleProps} from '@mui/material/DialogTitle';
import {IconButton} from '../Button/IconButton';
import {Divider} from '../Divider/Divider';
import {Box} from '../Box/Box';
import CloseIcon from '@mui/icons-material/Close';
import {styled} from '@mui/material/styles';
import {useModalContext} from './ModalContext';

export interface ModalTitleProps extends MaterialDialogTitleProps {
    /**
     * Includes divider
     * @default false
     */
    divider?: boolean;
}

const StyledCloseButton = styled(IconButton)({
    marginLeft: 'auto',
    marginRight: '-.75rem'
});

const StyledModalTitle = styled(MaterialDialogTitle)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.tokens.FuelSpacing1,
    fontSize: theme.tokens.FuelFontSizeXl,
    lineHeight: theme.tokens.FuelLineHeightXl
}));

export const ModalTitle = React.forwardRef<any, ModalTitleProps>(
    (
        {
            children,
            divider = false,
            ...props
        },
        ref
    ) => {
        const {
            onClose,
            showClose
        } = useModalContext();

        return (
            <>
                <StyledModalTitle
                    ref={ref}
                    {...props}
                >
                    {children}
                    {showClose ? (
                        <StyledCloseButton
                            aria-label='close'
                            onClick={onClose}
                            size='large'
                        >
                            <CloseIcon/>
                        </StyledCloseButton>
                    ) : null}
                </StyledModalTitle>
                { divider &&
                    <Box mb={2}>
                        <Divider/>
                    </Box>
                }
            </>
        );
    });

ModalTitle.displayName = 'ModalTitle';
